<template>
  <v-card class="pa-4 mb-4" outlined>
    <v-row align="center">
      <v-col cols="12" md="3">
        <v-text-field
          :label="$t('adminActionLogs.student_dni')"
          :value="value.rowPk"
          @input="manageInput('rowPk', $event)"
          hide-details
          dense
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          :label="$t('adminActionLogs.table')"
          :items="tableOptions"
          :value="value.tableName"
          @input="manageInput('tableName', $event)"
          hide-details
          dense
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          :label="$t('adminActionLogs.actor')"
          :value="value.actor"
          @input="manageInput('actor', $event)"
          hide-details
          dense
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          :label="$t('adminActionLogs.from')"
          type="date"
          :value="value.from"
          @change="manageInput('from', $event)"
          hide-details
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          :label="$t('adminActionLogs.to')"
          type="date"
          :value="value.to"
          @change="manageInput('to', $event)"
          hide-details
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <span class="grey--text text-caption mr-4 align-self-center">
          {{ $t('adminActionLogs.filter_hint') }}
        </span>
        <v-btn color="deep-purple lighten-1" dark small @click="search">
          {{ $t('common.filter') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'AdminActionLogsFilter',
  props: {
    value: {
      type: Object,
      default: () => ({
        rowPk: '', tableName: '', actor: '', from: '', to: '',
      }),
    },
  },
  data: () => ({
    tableOptions: [
      { text: 'bookuser', value: 'bookuser' },
      { text: 'courseteacher', value: 'courseteacher' },
    ],
  }),
  methods: {
    manageInput(key, newValue) {
      this.$emit('input', { ...this.value, [key]: newValue });
    },
    search() {
      this.$emit('search');
    },
  },
};
</script>
